<template>
  <div class="parent_div">
    <dd-header />
    <h2 class="hakotan_title">お支払い方法</h2>
    <div class="wrapper">
      <div class="main_content">
        <dd-menu ref="menuRef"/>
        <div>
          <section class="payment_section">
            <div class="payment_area">
              <div class="payment_msg">
                <div>
                  以下の方法でお支払いすることができます。お客様のご入金が確認できてから制作に移らせていただきます。
                </div>
                <div>
                  ご入金のタイミングによっては、お届け日が前後する可能性がありますことご了承ください。
                </div>
              </div>
            </div>
            <div class="payment_credit_area">
              <div class="payment_title">クレジットカードでお支払い</div>
              <div class="payment_msg">
                以下のマークがついているクレジットカードでお支払いいただけます。お支払い方法は一括払いのみとなっております。
                ご注文の確認が出来次第、製造を開始いたします。
              </div>
              <div class="credit_img">
                <img :src="getImage('guide/credit-card.webp')" />
              </div>
              <div class="payment_title">金融機関でのお支払い</div>
              <div class="payment_msg">
                <div>
                  商品は入金確認後に製造開始いたします。 お振込み期限を過ぎますと希望納期に間に合わない場合がございます。
                </div>
                <div>
                  決済ページにより振込先情報・振込期限をご確認の上、期間内にお支払いいただけますようお願い致します。
                </div>
              </div>
              <div class="payment_title" v-if="isCorpLogin">掛け払いサービスについて</div>
              <div class="payment_msg" v-if="isCorpLogin">
                <div>
                  法人のお客様は、「<span class="link" @click="deferPayment">後払いサービス</span>」をご利用いただけます。 ＊申込みと審査が必要となります。
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
    <dd-footer />
  </div>
</template>
<script>
import * as App from '../../utils/App'
import {DC_STORAGE_KEY} from '../../constants/App'
import DcHeader from '../components/common/DcHeader'
import DcFooter from '../components/common/DcFooter'
import DDLeftMenu from '../components/top/DcLeftMenu'

export default {
  components: {
    'dd-header': DcHeader,
    'dd-footer': DcFooter,
    'dd-menu': DDLeftMenu
  },
  data () {
    return {
      pageKey: 'dcGuidePayment',
      user: {}
    }
  },
  computed: {
    isCorpLogin: function () {
      if (!this.user || Object.keys(this.user).length <= 0) return false
      if (this.user.userId === undefined) return false
      if (this.user.userLevel === 2) return true
      if (this.user.userLevel === 1) return true
      return false
    }
  },
  methods: {
    getImage: function (image) {
      return App.getYasumokuResource(image)
    },
    deferPayment: function () {
      this.$router.push({
        name: 'DcPaymentService'
      })
    }
  },
  created: function () {
    this.user = App.getLocalStorage(DC_STORAGE_KEY.USER_INFO)
  }
}
</script>
<style src="../css/dctop4.scss" lang="scss" scoped></style>
<style src="../css/dc-guide.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/hakotan/pages/DcGuidePayment.vue